import { Helmet } from "react-helmet-async";
import Navbar from "../../components/navbar/navbar";
import "./terms-and-conditions.css";

const TermsAndConditions = () => {
  const callOutFee = "$80+GST";

  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Handyman In Melbourne</title>
        <meta
          name="description"
          content="Read the booking, quote, deposit, parking, payment and weather terms for Handyman In Melbourne."
        />
        <link rel="canonical" href="https://handymaninmelbourne.au/terms-and-conditions" />
      </Helmet>

      <Navbar />

      <main id="main-content" className="terms-page">
        <header className="terms-hero">
          <div className="terms-container">
            <h1>Terms and Conditions</h1>
          </div>
        </header>

        <article className="terms-content">
          <p className="terms-updated">Last updated: 1 October 2026</p>
          <p>
            These terms apply to handyman services provided by Handyman In Melbourne
            (“we”, “us” or “our”). By accepting a quote or confirming a booking, you
            agree to these terms.
          </p>

          <section>
            <h2>Bookings and contact details</h2>
            <p>
              To arrange a booking, we need your name, the job address and a mobile
              number. We’ll contact you by text to confirm the scheduled date. We’ll
              also send a text reminder the day before the job. Please reply to
              confirm and ensure someone can provide access at the agreed time.
            </p>
          </section>

          <section>
            <h2>Estimates and quotes</h2>
            <p>
              We’ll respond to your request by text with an estimate based on the
              information and photos you provide. A formal written quote is available
              on request. Formal quotes are valid for 30 days from the date they are
              issued, unless the quote states otherwise.
            </p>
            <p>
              Prices are based on the scope of work and the information available
              when we prepare the quote. A quote covers only the work and materials
              specifically listed in it. Changes to the scope may require a revised
              quote.
            </p>
            <p>
              If you request additional work, or we identify extra work or materials
              that are needed, we’ll explain the change and any additional cost and
              get your approval before proceeding. Approved additional work may be
              charged separately.
            </p>
          </section>

          <section>
            <h2>Inaccurate information and wrong scope</h2>
            <p>
              Please provide accurate information about the job. If we arrive on-site and cannot carry out the work due to 
              inaccurate details, incorrect job scope descriptions, or wrong information provided regarding the job, 
              the job cannot be completed on the scheduled date resulting in wasted travel, a call-out fee of {callOutFee} will apply, 
              and the quote will need to be revised.
            </p>
          </section>

          <section>
            <h2>Customer-supplied materials and parts</h2>
            <p>
              If parts, fixtures, or materials are supplied by you, you are responsible for ensuring they are correct and suitable. 
              If you got the wrong size, the wrong stuff, or incorrect items (including other circumstances) resulting in us 
              being unable to complete the job on the day, a call-out fee of {callOutFee} will apply for the extra travel.
            </p>
          </section>

          <section>
            <h2>Existing conditions and concealed problems</h2>
            <p>
              Our quote is based on conditions that are visible or disclosed to us
              when we prepare it. Concealed damage, deterioration, unsuitable
              surfaces or substrates, hidden services, or other conditions that could
              not reasonably be identified beforehand may affect the work or require
              additional work.
            </p>
            <p>
              If we discover a condition that changes the scope, we’ll explain the
              issue and any proposed additional cost. We’ll get your approval before
              carrying out the additional work.
            </p>
          </section>

          <section>
            <h2>Site inspections</h2>
            <p>
              If you request an on-site inspection, an inspection fee of {callOutFee} applies. If you later accept our quote for the work,
              we’ll credit that fee against the final price.
            </p>
          </section>

          <section>
            <h2>Access and missed appointments</h2>
            <p>
              If you don’t respond to our reminder and no one is available to provide
              access when we arrive at the agreed time, a call-out fee of {callOutFee} will apply.
            </p>
          </section>

          <section>
            <h2>Deposits</h2>
            <p>
              For jobs costing more than <strong>$1,000+GST</strong>, a
              <strong> 30% deposit</strong> is required to secure the booking. We’ll
              confirm the deposit amount and payment details before the booking is
              finalised.
            </p>
          </section>

          <section>
            <h2>Outdoor work and weather</h2>
            <p>
              Outdoor work is subject to suitable weather conditions. If your job is
              scheduled more than 14 days in advance, we’ll contact you 7 days before
              the scheduled date with an update on the weather and whether we expect
              to proceed. If weather prevents us from carrying out the work safely or
              properly, we’ll contact you to arrange another date.
            </p>
          </section>

          <section>
            <h2>Parking</h2>
            <p>
              If paid parking is required to carry out your job, the parking cost will
              be added to your invoice. Where possible, we’ll let you know about the
              expected parking cost before work begins.
            </p>
          </section>

          <section>
            <h2>Payment</h2>
            <p>We accept cash, bank transfer and card payments.</p>
            <p>Payment due on invoice date.</p>
            <p>You will receive automatic payment reminders.</p>
            <p>
              FAILURE TO PAY: A $50.00 late fee (to cover admin costs) will be added 
              to invoiced amounts if remaining unpaid beyond 10 DAYS from the DUE DATE, 
              and processes to recover the debt will commence. In the event that Handyman In Melbourne 
              incurs third party costs in attempting to recover any overdue amounts from the client, 
              those third party costs will be added to the debt owed by the client. 
              Third party costs include legal costs incurred on a solicitor-client basis, costs 
              charged by a debt collection agency and related court costs.
            </p>
          </section>

          <section>
            <h2>Customer access and job preparation</h2>
            <p>
              Please provide accurate information about the job and ensure the work
              area is accessible and ready for us to carry out the agreed work. Let
              us know beforehand about access requirements or site conditions that
              may affect the job.
            </p>
          </section>

          <section className="terms-contact">
            <h2>Questions?</h2>
            <p>Contact us if you have a question about these terms or your booking.</p>
            <a href="tel:0412279273">0412 279 273</a>
            <a href="mailto:info@handymaninmelbourne.au">info@handymaninmelbourne.au</a>
          </section>
        </article>
      </main>
    </>
  );
};

export default TermsAndConditions;